import { useMutation } from '@apollo/client/react';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useState } from 'react';

import { DeactivateOtpSecretsDocument } from '~/graphql/generated/graphql';
import { twoFactorAuthModalState } from '~/state/layouts/SharedAppShell/atoms';

export const useDeactivateOtpSecrets = () => {
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [deactivate] = useMutation(DeactivateOtpSecretsDocument);

  const resetTwoFactorAuthModalState = useResetAtom(twoFactorAuthModalState);

  const handleSubmit = useCallback(async () => {
    setIsDeactivating(true);
    setError(null);

    try {
      await deactivate({
        variables: {
          input: {},
        },
      });
      resetTwoFactorAuthModalState();
    } catch (_error) {
      setError(_error?.message || 'エラーが発生しました');
    }
    setIsDeactivating(false);
  }, [deactivate, resetTwoFactorAuthModalState]);

  return {
    deactivating: isDeactivating,
    error,
    handleSubmit,
  };
};
